import { WEBURL } from "../../constant/comman";

const getFullUrl = (endPoint) => {
  return (WEBURL + endPoint).replace(/([^:]\/)\/+/g, "$1");
};

const getAuthHeaders = (authtoken) => {
  return {
    authtoken: authtoken,
    authorization: authtoken ? (authtoken.startsWith('Berear') || authtoken.startsWith('Bearer') ? authtoken : `Berear ${authtoken}`) : '',
  };
};

export async function listCertificateTemplates(authtoken) {
  try {
    let url = getFullUrl("v1/auth/admin/certificate-templates");
    let response = await fetch(url, {
      method: "GET",
      headers: {
        ...getAuthHeaders(authtoken),
        "Content-Type": "application/json"
      }
    });
    return await response.json();
  } catch (error) {
    console.error("Error fetching certificate templates:", error);
    throw error;
  }
}

export async function addCertificateTemplate(authtoken, formData) {
  try {
    let url = getFullUrl("v1/auth/admin/add-certificate-template");
    let isFormData = formData instanceof FormData;
    let headers = getAuthHeaders(authtoken);
    if (!isFormData) {
      headers["Content-Type"] = "application/json";
    }
    let response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: isFormData ? formData : JSON.stringify(formData)
    });
    return await response.json();
  } catch (error) {
    console.error("Error adding certificate template:", error);
    throw error;
  }
}

export async function editCertificateTemplate(authtoken, formData) {
  try {
    let url = getFullUrl("v1/auth/admin/edit-certificate-template");
    let isFormData = formData instanceof FormData;
    let headers = getAuthHeaders(authtoken);
    if (!isFormData) {
      headers["Content-Type"] = "application/json";
    }
    let response = await fetch(url, {
      method: "PUT",
      headers: headers,
      body: isFormData ? formData : JSON.stringify(formData)
    });
    return await response.json();
  } catch (error) {
    console.error("Error editing certificate template:", error);
    throw error;
  }
}

export async function previewCertificateTemplate(authtoken, formData) {
  try {
    let url = getFullUrl("v1/auth/admin/preview-certificate-template");
    let isFormData = formData instanceof FormData;
    let headers = getAuthHeaders(authtoken);
    if (!isFormData) {
      headers["Content-Type"] = "application/json";
    }
    let response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: isFormData ? formData : JSON.stringify(formData)
    });
    return await response.json();
  } catch (error) {
    console.error("Error previewing certificate template:", error);
    throw error;
  }
}

export async function deleteCertificateTemplate(authtoken, id) {
  try {
    let url = getFullUrl(`v1/auth/admin/delete-certificate-template/${id}`);
    console.log("🗑️ [GRAPH API] Sending DELETE request to URL:", url);
    let response = await fetch(url, {
      method: "DELETE",
      headers: {
        ...getAuthHeaders(authtoken),
        "Content-Type": "application/json"
      }
    });
    let data = await response.json();
    console.log("🗑️ [GRAPH API] Received response from DELETE:", response.status, data);
    return data;
  } catch (error) {
    console.error("🗑️ [GRAPH API ERROR] Error deleting certificate template:", error);
    throw error;
  }
}
